<template>
    <div>
        <detalhe
            :size="cabecalho"
            v-for="eventoConfiguracao in eventoConfigIntegracao"
            :key="eventoConfiguracao.chave"
            :titulo="eventoConfiguracao.chave"
            :obrigatorio="eventoConfiguracao.chave !== 'CLASSIFICACAO'"
        >
            <InputText type="text" v-model="eventoConfiguracao.valor" style="width: 100%" maxlength="100" />
        </detalhe>

        <div class="mt-4">
            <h5 class="mb-1">Cores do cordão por categoria</h5>
            <p class="text-sm mb-3">
                Associe cada categoria (a resposta que vem do Sympla no campo indicado em CLASSIFICAÇÃO) a uma cor do cordão. Deixe sem itens se não usar.
            </p>

            <div v-for="(item, index) in mapaCores" :key="index" class="formgrid grid p-fluid align-items-end mb-2">
                <div class="field col-12 md:col-4">
                    <label>Categoria (resposta)</label>
                    <InputText v-model="item.resposta" placeholder="Ex.: MEI" />
                </div>
                <div class="field col-12 md:col-3">
                    <label>Nome da cor</label>
                    <InputText v-model="item.nome" placeholder="Ex.: Verde" />
                </div>
                <div class="field col-12 md:col-3">
                    <label>Cor</label>
                    <div class="flex align-items-center">
                        <ColorPicker v-model="item.cor" format="hex" />
                        <InputText v-model="item.cor" class="ml-2" placeholder="RRGGBB" maxlength="7" />
                    </div>
                </div>
                <div class="field col-12 md:col-2">
                    <Button icon="pi pi-trash" class="p-button-danger p-button-text" @click="removerCor(index)" title="Remover categoria" />
                </div>
            </div>

            <Button icon="pi pi-plus" label="Adicionar categoria" class="p-button-outlined" @click="adicionarCor()" />
        </div>
    </div>
</template>

<script>
import EventosServices from './services';

export default {
    components: {},

    props: {
        evento: {
            type: Object,
        },
    },

    emits: ['obterEventoAtualizado'],

    data() {
        return {
            cabecalho: '140',
            activeIndex: 0,
            eventoConfigIntegracao: null,
            mapaCores: [],
            primeirasConfiguracoes: [
                {
                    chave: 'CNPJ',
                    valor: '',
                },
                {
                    chave: 'CPF',
                    valor: '',
                },
                {
                    chave: 'DATA_NASCIMENTO',
                    valor: '',
                },
                {
                    chave: 'GENERO',
                    valor: '',
                },
                {
                    chave: 'TELEFONE',
                    valor: '',
                },
                {
                    chave: 'CLASSIFICACAO',
                    valor: '',
                },
            ],
        };
    },

    methods: {
        obterEventoConfigsIntegracao() {
            this.$store.dispatch('addRequest');
            EventosServices.obterConfigsIntegracaoEvento(this.$route.params.id).then((response) => {
                if (response?.success && response.data?.length) {
                    this.eventoConfigIntegracao = response.data;
                } else {
                    this.eventoConfigIntegracao = [...this.primeirasConfiguracoes];
                }
                this.garantirClassificacao();
                this.carregarMapaCores();
                this.$store.dispatch('removeRequest');
            });
        },

        garantirClassificacao() {
            if (!this.eventoConfigIntegracao.some((c) => c.chave === 'CLASSIFICACAO')) {
                this.eventoConfigIntegracao.push({ chave: 'CLASSIFICACAO', valor: '' });
            }
        },

        carregarMapaCores() {
            let lista = [];
            try {
                if (this.evento?.mapaCorCordao) {
                    lista = JSON.parse(this.evento.mapaCorCordao) || [];
                }
            } catch (e) {
                lista = [];
            }
            this.mapaCores = lista.map((i) => ({
                resposta: i.resposta,
                nome: i.nome,
                cor: (i.cor || '').replace('#', ''),
            }));
        },

        adicionarCor() {
            this.mapaCores.push({ resposta: '', nome: '', cor: '' });
        },

        removerCor(index) {
            this.mapaCores.splice(index, 1);
        },

        montarMapaCoresJson() {
            const lista = (this.mapaCores || [])
                .filter((i) => i.resposta && i.resposta.trim())
                .map((i) => ({
                    resposta: i.resposta.trim(),
                    nome: (i.nome || '').trim(),
                    cor: i.cor ? '#' + String(i.cor).replace('#', '') : '',
                }));
            return JSON.stringify(lista);
        },

        atualizar() {
            this.$store.dispatch('addRequest');
            const eventoId = this.$route.params.id;
            const eventoConfiguracao = {
                configuracoes: [...this.eventoConfigIntegracao],
            };
            EventosServices.atualizarConfigsIntegracaoEvento(eventoId, eventoConfiguracao)
                .then((response) => {
                    if (response?.success) {
                        this.eventoConfigIntegracao = response.data;
                        this.garantirClassificacao();
                        return EventosServices.atualizarMapaCorCordao(eventoId, this.montarMapaCoresJson());
                    }
                    this.erros = response.errors;
                    return null;
                })
                .then((respMapa) => {
                    if (respMapa) {
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Configurações Evento',
                            detail: 'Configurações do evento atualizadas com sucesso',
                            life: 3000,
                        });
                        this.$emit('obterEventoAtualizado');
                    }
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },
    },

    computed: {
        formularioOk() {
            return this.eventoConfigIntegracao?.every((config) => {
                if (config.chave === 'CLASSIFICACAO') return true; // opcional — não configurado não influencia
                return config.valor != '' && config.valor != null;
            });
        },
    },

    watch: {
        evento() {
            if (this.evento) {
                this.obterEventoConfigsIntegracao();
            }
        },
    },

    mounted() {
        if (this.evento) {
            this.obterEventoConfigsIntegracao();
        }
    },
};
</script>
